import { clsx } from "clsx";
import { Flex } from "@/components/Flex/Flex";

/* Inline glyphs for the next-steps cards. All decorative, all fixed artwork. */

export function ArrowIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5"
    >
      <path
        d="M4 10h11M11 5l5 5-5 5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CalendarIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" fill="none" className="h-4 w-4 shrink-0">
      <rect
        x="2.5"
        y="4"
        width="15"
        height="13.5"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="M2.7 8.2h14.6M6.7 2.2v3.2M13.3 2.2v3.2"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ChevronIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 8 14"
      fill="none"
      className="h-3.5 w-2 shrink-0 transition-transform duration-300 group-hover:translate-x-0.5"
    >
      <path
        d="M1.5 1L7 7l-5.5 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MailIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" fill="none" className="mt-0.5 h-4 w-4 shrink-0">
      <rect
        x="1.8"
        y="4"
        width="16.4"
        height="12"
        rx="2.4"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M2.7 5.8L10 10.7l7.3-4.9"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function TelegramIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
      <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71l-4.14-3.05-1.99 1.93c-.23.23-.42.42-.86.42z" />
    </svg>
  );
}

export function CheckBadge({ plain = false }: { plain?: boolean }) {
  return (
    <Flex
      as="span"
      aria-hidden="true"
      align="center"
      justify="center"
      className={clsx(
        "h-9 w-9 shrink-0 rounded-full",
        // On the purple block the disc is a white scrim; on a white card that is
        // invisible, so it takes a brand tint instead.
        plain ? "bg-brand/15 text-brand" : "bg-brand-content/20",
      )}
    >
      <svg aria-hidden="true" viewBox="0 0 20 20" fill="none" className="h-5 w-5">
        <path
          d="M4 10.5l3.5 3.5L16 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Flex>
  );
}

/** Tween a number to `target` with requestAnimationFrame (easeOutCubic). Starts
 *  at 0 so SSR (0) and hydration match; jumps straight to `target` when the user
 *  prefers reduced motion or `duration <= 0` (restored state). */
